var map = {
	"./Bills.png": 77265,
	"./Bills.svg": 41877,
	"./Clothes.png": 27879,
	"./Clothes.svg": 16483,
	"./Coffee.png": 91067,
	"./Coffee.svg": 55901,
	"./CreditCards.png": 84163,
	"./CreditCards.svg": 61363,
	"./Dark_excludedFromAnalysisIcon.png": 13443,
	"./Dark_excludedFromAnalysisIcon.svg": 45443,
	"./Debts.png": 50593,
	"./Debts.svg": 14205,
	"./Drinks.png": 74286,
	"./Drinks.svg": 25972,
	"./EatingOut.png": 97345,
	"./EatingOut.svg": 76409,
	"./Education.png": 14685,
	"./Education.svg": 38177,
	"./Entertainment.png": 69637,
	"./Entertainment.svg": 84025,
	"./Family.png": 21935,
	"./Family.svg": 26993,
	"./Fitness.png": 5455,
	"./Fitness.svg": 87539,
	"./Gambling.png": 97190,
	"./Gambling.svg": 53152,
	"./Gifts.png": 66834,
	"./Gifts.svg": 4182,
	"./Groceries.png": 34570,
	"./Groceries.svg": 50194,
	"./Holiday.png": 67779,
	"./Holiday.svg": 61683,
	"./Home&Garden.png": 90573,
	"./Home&Garden.svg": 66133,
	"./Home.png": 52442,
	"./Home.svg": 43968,
	"./Insurance.png": 56219,
	"./Insurance.svg": 48687,
	"./InternalTransfers.png": 438,
	"./InternalTransfers.svg": 35466,
	"./InternalTransfersIcon.png": 13801,
	"./InternalTransfersIcon.svg": 32137,
	"./Investments.png": 60729,
	"./Investments.svg": 72625,
	"./LargePurchases.png": 23012,
	"./LargePurchases.svg": 66126,
	"./Medical.png": 59658,
	"./Medical.svg": 42974,
	"./Other.png": 33289,
	"./Other.svg": 67933,
	"./Pets.png": 92189,
	"./Pets.svg": 73411,
	"./Resources.png": 75136,
	"./Resources.svg": 58596,
	"./Salary.png": 11321,
	"./Salary.svg": 89531,
	"./Savings.png": 56242,
	"./Savings.svg": 41338,
	"./Selfcare.png": 82630,
	"./Selfcare.svg": 19908,
	"./Shopping.png": 69315,
	"./Shopping.svg": 55617,
	"./Socialising.png": 77452,
	"./Socialising.svg": 38628,
	"./Takeaways.png": 82865,
	"./Takeaways.svg": 73977,
	"./Transport.png": 74256,
	"./Transport.svg": 64360,
	"./Travel.png": 92899,
	"./Travel.svg": 22501,
	"./Uncategorized.png": 57069,
	"./Uncategorized.svg": 40225,
	"./Vehicle.png": 6479,
	"./Vehicle.svg": 1723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;